import { assocPath } from "ramda";
import * as consts from "../constants";

export default (state = {}, action) => {
  switch (action.type) {
    case "INITIALIZE_STORE":
      return { ...{} };
    case "INITIALIZE_STORE_SERVICEREMOVAL":
      return {
        ...state,
        activeIndex: 0,
        pageName: consts.SERVICE_REMOVAL_NAME,
        parcel: null,
        isSearchBPCalled: false,
        isRenderSchedule: false,
      };
    case "INITIALIZE_STORE_NEWGASLINE":
      return {
        ...state,
        activeIndex: 0,
        pageName: consts.NEW_GAS_LINE_NAME,
        parcel: null,
        isSearchBPCalled: false,
        isRenderSchedule: false,
      };
    case "INITIALIZE_DASHBOARD":
      return {
        ...state,
        activeIndex: 0,
        pageName: "dashboard",
        submittedProject: null,
      };
    case "INITIALIZE_PROJECTDETAILS":
      return { ...state, pageName: "projectdetails" };
    case "INITIALIZE_REGISTER": {
      if (window.osa && window.osa.lookup && window.osa.lookup.customerDetails)
        window.osa.lookup.customerDetails = null;
      return {
        ...state,
        pageName: "register",
        invalidUserName: null,
        invalidEmail: null,
        invalidPassword: null,
        user: null,
        bupaChecked: null,
        bupaVerifyErrorMsg: null,
        bupaVerifyRetrieErrorMsg: null,
        verifyAccountRetries: null,
      };
    }
    case "INITIALIZE_PROFILE":
      return { ...state };
    case "LOOKUP": {
      const {
        lookup,
        countryLookup,
        faq,
        cities,
        streetTypes,
        siteUrl,
        googleAnalyticsId,
        requiredByDateOffsetDays,
        appVersion,
        ...p
      } = action.data;
      window.osa = {
        lookup: lookup[state.pageName],
        commonLookup: lookup["common"],
        countryLookup,
        faq,
        cities,
        streetTypes,
        siteUrl,
        googleAnalyticsId,
        requiredByDateOffsetDays,
        appVersion,
      };
      return { ...state, ...p };
    }
    case "SET_SEARCH_BP_CALLED":
      return { ...state, isSearchBPCalled: action.value };
    case "SET_IS_RENDER_SCHEDULE":
      return { ...state, isRenderSchedule: action.value };
    case "USER":
      return { ...state, user: action.user };
    case "FORGOT_PASSWORD_SUCCESS":
      return { ...state, forgotPasswordSuccess: action.forgotPasswordSuccess };
    case "RESET_PASSWORD_SUCCESS":
      return { ...state, resetPasswordSuccess: action.resetPasswordSuccess };
    case "UPDATE_EMAIL_SUCCESS":
      return { ...state, updateEmailSuccess: action.updateEmailSuccess };
    case "SAVE_PROFILE_SUCCESS":
      return { ...state, saveProfileSuccess: action.saveProfileSuccess };
    case "INVALID_USER_NAME":
      return { ...state, invalidUserName: action.invalidUserName };
    case "INVALID_PASSWORD":
      return { ...state, invalidPassword: action.invalidPassword };
    case "INVALID_EMAIL":
      return { ...state, invalidEmail: action.invalidEmail };
    case "LOGOUT":
      return { ...state, user: action.user };
    case "PARCEL":
      return { ...state, parcel: action.parcel };
    case "SAP_PREMISE":
      return { ...state, sapPremise: action.data };
    case "PROJECT_DETAILS":
      return { ...state, projectDetails: action.projectDetails };
    case "PROJECT_RESET_SUCCESS":
      return { ...state, project: { ...state.project, isSuccess: false } };
    case "APPOINTMENTS":
      return { ...state, schedule: { ...state.schedule, ...action.schedule } };
    case "DATE_SELECTED":
      return { ...state, schedule: { ...state.schedule, ...action.m } };
    case "DATE_UNSELECTED":
      return { ...state, schedule: null };
    case "ADD_EMAIL_SUCCESS":
      return { ...state, addEmailSuccess: action.data };
    case "DELETE_EMAIL_SUCCESS":
      return { ...state, deleteEmailSuccess: action.data };
    case "VERIFY_EMAIL_SUCCESS":
      return { ...state, verifyEmailSuccess: action.data };
    case "UPDATE_NOTIFICATION_SUCCESS":
      return { ...state, updateNotificationSuccess: action.data };
    case "SCHEDULE_UPDATED":
      return assocPath(["project", "scheduleUpdated"], true, state);
    case "CLEAR_SCHEDULE_UPDATED":
      return assocPath(["project", "scheduleUpdated"], false, state);
    case "SUBMITTED_PROJECT":
      return { ...state, submittedProject: action.submittedProject };
    case "CANCELLED_PROJECT":
      return { ...state, cancelledProject: action.cancelledProject };
    case "OFFRAMP":
      return { ...state, offramp: action.offramp, serviceCost: null };
    case "BUPA_CHECKED": {
      const m = action.model;

      const bupaVerifyErrorMsg1 =
        window.osa.lookup &&
          window.osa.lookup.customerDetails.errors
            .FortisBCAccountNumberUserProfileExist
          ? window.osa.lookup.customerDetails.errors
            .FortisBCAccountNumberUserProfileExist
          : window.osa.commonLookup.userProfile.errors.profileExist;
      const bupaVerifyErrorMsg2 =
        window.osa.lookup &&
          window.osa.lookup.customerDetails.errors.FortisBCAccountNoValidateField
          ? window.osa.lookup.customerDetails.errors
            .FortisBCAccountNoValidateField
          : window.osa.commonLookup.userProfile.errors.accountNoValidateField;

      if (m.isBPHasUserProfile) {
        //Bp has user profile
        if (state.user && state.user.isAuthenticated) {
          //user logged-in
          return state;
        } else {
          return {
            ...state,
            bupaChecked: null,
            bupaVerifyErrorMsg: bupaVerifyErrorMsg1,
          };
        }
      } else {
        if (m.model.length > 0)
          //some validation field found
          return { ...state, bupaChecked: m.model };
        else
          return {
            ...state,
            bupaChecked: null,
            bupaVerifyErrorMsg: bupaVerifyErrorMsg2,
          };
      }
    }
    case "BUPA_CHECKED_FAILED": {
      const m = action.model;
      const bupaVerifyErrorMsg =
        window.osa.lookup &&
          window.osa.lookup.customerDetails.errors.FortisBCAccountNumberNotFound
          ? window.osa.lookup.customerDetails.errors
            .FortisBCAccountNumberNotFound
          : window.osa.commonLookup.userProfile.errors.accountNumberNotFound;

      if (m.isSAPFailed) {
        return state;
      } else {
        return { ...state, bupaChecked: null, bupaVerifyErrorMsg };
      }
    }
    case "CLEAR_BUPA_VERIFY_FAILED":
      return {
        ...state,
        bupaVerifyErrorMsg: "",
        bupaVerifyRetrieErrorMsg: "",
      };
    case "BUPA_VERIFIED":
      return {
        ...state,
        user: { ...state.user, bpNumber: action.model.bpModel.bpNumber },
        allowDOBEdit: action.model.bpModel.dob,
      };
    case "BUPA_VERIFY_FAILED": {
      const bupaVerifyErrorMsg =
        window.osa.lookup &&
          window.osa.lookup.customerDetails.errors.FortisBCAccountNumberNotFound
          ? window.osa.lookup.customerDetails.errors
            .FortisBCAccountNumberNotFound
          : window.osa.commonLookup.userProfile.errors.accountNumberNotFound;
      const accountNoValidateField =
        window.osa.lookup &&
          window.osa.lookup.customerDetails.errors.FortisBCAccountNoValidateField
          ? window.osa.lookup.customerDetails.errors
            .FortisBCAccountNoValidateField
          : window.osa.commonLookup.userProfile.errors.accountNoValidateField;

      return {
        ...state,
        verifyAccountRetries: action.model.attempts,
        verifyAccountExceed: action.model.attempts >= 3,
        bupaVerifyErrorMsg,
        bupaVerifyRetrieErrorMsg:
          action.model.attempts >= 3 ? accountNoValidateField : "",
      };
    }
    case "BUPA_SEARCHED": //{"success":true,"model":{"bpNumber":"0025617060","baNumber":"000003936400"},"bpUser":null}
      return {
        ...state,
        bpSearchResult: action.data,
        isSearchBPCalled: true,
      };
    case "BUPA_CREATED":
      return {
        ...state,
        bupaCreated: true,
        user: { ...state.user, bpNumber: action.data.model.bpNumber },
        baNumber: action.data.model.baNumber,
      };
    case "BUPA_CREATE_FAILED":
      return { ...state, bupaCreated: false };
    case "BUPA_UPDATED": //{"success":true,"model":"6317052564"}->model:ObjectId
      return { ...state, bupaCreated: true };
    case "BUAG_ADDED": //{"success":true,"model":"000003936390"} -> model:BaNumber
      return { ...state, bupaCreated: true, baNumber: action.data.model };
    case "BP_SELECTED":
      return { ...state, isBPSelected: action.isBPSelected };
    case "NEXT_STEP_CLICKED":
      return { ...state, activeIndex: action.activeIndex };
    case "REQCALL":
      return { ...state, reqcall: action.reqcall };
    case "ERROR":
      return { ...state, error: action.message };
    case "LOADING": {
      const loading = state.isLoading
        ? state.isLoading + action.val
        : action.val;
      return { ...state, isLoading: loading };
    }
    case "SHOW_MODAL":
      return { ...state, modal: action.data };
    case "CLOSE_MODAL":
      return { ...state, modal: null };
    case "SHOW_SESSION_EXPIRED": {
      const sessionModal =
        window.osa &&
        window.osa.commonLookup.modal &&
        window.osa.commonLookup.modal.sessionExpired;
      const header = (sessionModal && sessionModal.header) || "Confirmation";
      const body =
        (sessionModal && sessionModal.body) ||
        "Session timed out !!! You have lost unsaved data due to inactivity for longer period.";
      const data = {
        headerText: header,
        bodyText: body,
        actionButtonText: "OK",
        closeButtonText: "Close",
        onActionClicked: () => {
          location.reload();
        },
      };
      return { ...state, modal: data };
    }
    case "PROJECT_DETAIL_RECEIVED":
      return { ...state, ...action.gasModel };
    case "PROJECT":
      return { ...state, project: action.project };
    case "PROJECT_LIST_RECEIVED":
      return { ...state, prjList: action.data };
    case "DB_SWITCH":
      return {
        ...state,
        prjList: state.prjList.map((x) =>
          x.status.toLowerCase() !== "submitted"
            ? x
            : { ...x, isAllEmail: action.on }
        ),
      };
    case "DB_SWITCH_PROJECT":
      return {
        ...state,
        prjList: state.prjList.map((x) =>
          x.projectNo !== action.prjNo ? x : { ...x, isAllEmail: action.on }
        ),
      };
    case "SET_GOOGLE_LOCATION":
      return {
        ...state,
        customAddress: { place: action.place, address: action.address },
      };
    case "CHECK_AVAILABILITY_SUCCESS":
      return {
        ...state,
        serviceCost: action.data.serviceCost,
        offramp: action.data.offramp,
      };
    case "CONTACTS_SAVED_FINISHED":
      return { ...state, allContactsSaved: action.allSavedSuccess };
    default:
      return state;
  }
};
